module.exports = __webpack_public_path__ + "img/geep-logo-no-bg-users-box.c1f19ddd.png";